<div class="user-inactivity">
  <ng-container *ngIf="displayDialogInactivity">
    <ng-container *ngIf="!isSessionExpired; else sessionExpiredDialog">
      <si-generic-dialog [displayDialog]="displayDialogInactivity"
                         [closable]="false"
                         [dialogTitle]="'SI_SESSION_EXPIRES_IN' | translate:{seconds: countdownTimeRemaining}"
                         dialogText="SI_SESSION_KEEP_OPEN_QUESTION"
                         button1Text="SI_YES"
                         button1Class="si-button_main"
                         button2Text="SI_NO"
                         button2Class="si-button_secondary"
                         (updateButton1Change)="onClickCloseDialogInactivity(true)"
                         (updateButton2Change)="onClickCloseDialogInactivity(false)"
      ></si-generic-dialog>
    </ng-container>
    <ng-template #sessionExpiredDialog>
      <si-generic-dialog [displayDialog]="displayDialogInactivity"
                         [closable]="false"
                         dialogTitle="SI_SESSION_EXPIRED"
                         dialogTitleStyleClass="text-center"
                         [centerButtons]="true"
                         button1Text="SI_LOGIN"
                         button1Class="si-button_main"
                         (updateButton1Change)="onClickGoToLogin()"
      ></si-generic-dialog>
    </ng-template>
  </ng-container>
</div>
